// src/graphql/mutations/jobMutations.js

// ==================== JOB TRIGGER MUTATIONS ====================

// Crawl Jobs
export const adminCrawlTender = `mutation AdminCrawlTender($tenderId: String!) {
    adminCrawlTender(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

export const adminCrawlAllTenders = `mutation AdminCrawlAllTenders($force: Boolean) {
    adminCrawlAllTenders(force: $force) {
        success
        message
        jobId
        error
    }
}`;

export const adminSyncTenders = `mutation AdminSyncTenders($onlyNew: Boolean, $skipTenderIds: [String!], $source: String) {
    adminSyncTenders(onlyNew: $onlyNew, skipTenderIds: $skipTenderIds, source: $source) {
        success
        message
        jobId
        error
    }
}`;

export const adminCheckNewTenders = `mutation AdminCheckNewTenders($input: CheckNewTendersInput) {
    adminCheckNewTenders(input: $input) {
        success
        message
        jobId
        error
    }
}`;

export const adminRefreshDocuments = `mutation AdminRefreshDocuments($tenderId: String!) {
    adminRefreshDocuments(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

// Assessment Jobs
export const adminAssessTender = `mutation AdminAssessTender($tenderId: String!, $companyId: String!) {
    adminAssessTender(tenderId: $tenderId, companyId: $companyId) {
        success
        message
        jobId
        error
    }
}`;

export const adminAssessAllTenders = `mutation AdminAssessAllTenders($companyId: String!, $limit: Int, $skipExisting: Boolean, $minRating: Int) {
    adminAssessAllTenders(companyId: $companyId, limit: $limit, skipExisting: $skipExisting, minRating: $minRating) {
        success
        message
        jobId
        error
    }
}`;

export const generateTenderNarrativeAssessment = `mutation GenerateTenderNarrativeAssessment($tenderId: String!, $language: String!, $forceRegenerate: Boolean) {
    generateTenderNarrativeAssessment(tenderId: $tenderId, language: $language, forceRegenerate: $forceRegenerate) {
        success
        message
        jobId
        error
    }
}`;

// Geocode Jobs
export const adminGeocodeTender = `mutation AdminGeocodeTender($tenderId: String!) {
    adminGeocodeTender(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

export const adminGeocodeAllTenders = `mutation AdminGeocodeAllTenders {
    adminGeocodeAllTenders {
        success
        message
        jobId
        error
    }
}`;

// Document Jobs
export const adminExtractDocumentText = `mutation AdminExtractDocumentText($documentId: String!) {
    adminExtractDocumentText(documentId: $documentId) {
        success
        message
        jobId
        error
    }
}`;

export const adminExtractTenderDocumentsText = `mutation AdminExtractTenderDocumentsText($tenderId: String!) {
    adminExtractTenderDocumentsText(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

export const adminExtractAllDocumentsText = `mutation AdminExtractAllDocumentsText($limit: Int) {
    adminExtractAllDocumentsText(limit: $limit) {
        success
        message
        jobId
        error
    }
}`;

export const adminConvertTenderDocuments = `mutation AdminConvertTenderDocuments($tenderId: String!) {
    adminConvertTenderDocuments(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

export const adminConvertAllDocuments = `mutation AdminConvertAllDocuments($limit: Int) {
    adminConvertAllDocuments(limit: $limit) {
        success
        message
        jobId
        error
    }
}`;

// Deep Crawl Jobs
export const adminDeepCrawlTender = `mutation AdminDeepCrawlTender($tenderId: String!, $forceRecrawl: Boolean) {
    adminDeepCrawlTender(tenderId: $tenderId, forceRecrawl: $forceRecrawl) {
        success
        message
        jobId
        error
    }
}`;

export const adminDeepCrawlByDomain = `mutation AdminDeepCrawlByDomain($input: DeepCrawlByDomainInput!) {
    adminDeepCrawlByDomain(input: $input) {
        success
        message
        jobId
        error
    }
}`;

export const adminDeepCrawlAll = `mutation AdminDeepCrawlAll($companyId: String, $favoritesOnly: Boolean, $minRating: Int, $limit: Int, $missingDocumentsOnly: Boolean) {
    adminDeepCrawlAll(companyId: $companyId, favoritesOnly: $favoritesOnly, minRating: $minRating, limit: $limit, missingDocumentsOnly: $missingDocumentsOnly) {
        success
        message
        jobId
        error
    }
}`;

// Index Jobs
export const adminIndexTender = `mutation AdminIndexTender($tenderId: String!) {
    adminIndexTender(tenderId: $tenderId) {
        success
        message
        jobId
        error
    }
}`;

export const adminIndexAllTenders = `mutation AdminIndexAllTenders($limit: Int, $batchSize: Int, $force: Boolean, $skipExisting: Boolean) {
    adminIndexAllTenders(limit: $limit, batchSize: $batchSize, force: $force, skipExisting: $skipExisting) {
        success
        message
        jobId
        error
    }
}`;

export const adminSearchCorpus = `mutation AdminSearchCorpus($companyId: String!, $candidateIds: [String!], $topK: Int, $includeEvidence: Boolean, $saveResults: Boolean) {
    adminSearchCorpus(companyId: $companyId, candidateIds: $candidateIds, topK: $topK, includeEvidence: $includeEvidence, saveResults: $saveResults) {
        success
        message
        jobId
        error
    }
}`;

export const adminRescoreCorpusV3 = `mutation AdminRescoreCorpusV3($companyId: String!, $tenderIds: [String!], $fromV2SearchLimit: Int, $rmModelVersion: String) {
    adminRescoreCorpusV3(companyId: $companyId, tenderIds: $tenderIds, fromV2SearchLimit: $fromV2SearchLimit, rmModelVersion: $rmModelVersion) {
        success
        message
        jobId
        error
    }
}`;

// Index Maintenance Jobs (Destructive)
export const adminRecreateIndex = `mutation AdminRecreateIndex {
    adminRecreateIndex {
        success
        message
        jobId
        error
    }
}`;

export const adminReverseRecreateIndex = `mutation AdminReverseRecreateIndex {
    adminReverseRecreateIndex {
        success
        message
        jobId
        error
    }
}`;

export const adminReverseIndexAllFingerprints = `mutation AdminReverseIndexAllFingerprints($limit: Int, $batchSize: Int, $includeInactive: Boolean) {
    adminReverseIndexAllFingerprints(limit: $limit, batchSize: $batchSize, includeInactive: $includeInactive) {
        success
        message
        jobId
        error
    }
}`;

// Saved Search Reports
export const adminSendSavedSearchReports = `mutation AdminSendSavedSearchReports($companyId: String, $force: Boolean) {
    adminSendSavedSearchReports(companyId: $companyId, force: $force) {
        success
        message
        jobId
        error
    }
}`;

// TED Query Generation
export const adminGenerateTedQuery = `mutation AdminGenerateTedQuery($companyId: String!) {
    adminGenerateTedQuery(companyId: $companyId) {
        success
        message
        jobId
        error
    }
}`;

// Document Normalization
export const adminNormalizeDocuments = `mutation AdminNormalizeDocuments($limit: Int, $dryRun: Boolean, $minSaved: Int) {
    adminNormalizeDocuments(limit: $limit, dryRun: $dryRun, minSaved: $minSaved) {
        success
        message
        jobId
        error
    }
}`;

// Transactional Email
export const adminSendEmail = `mutation AdminSendEmail($input: SendEmailInput!) {
    adminSendEmail(input: $input) {
        success
        message
        jobId
        error
    }
}`;

// Workflow Jobs
export const adminRunWorkflow = `mutation AdminRunWorkflow($templateName: String!, $input: JSON, $cronSchedule: String) {
    adminRunWorkflow(templateName: $templateName, input: $input, cronSchedule: $cronSchedule) {
        success
        message
        jobId
        error
    }
}`;

export const adminRunCompanyWorkflows = `mutation AdminRunCompanyWorkflows($templateName: String!, $input: JSON, $staggerSeconds: Int, $companyIds: [String!], $cronSchedule: String) {
    adminRunCompanyWorkflows(templateName: $templateName, input: $input, staggerSeconds: $staggerSeconds, companyIds: $companyIds, cronSchedule: $cronSchedule) {
        success
        message
        jobId
        error
    }
}`;

// Generic job trigger — enqueue any backend-registered job type by name with
// raw JSON parameters. Used as the fallback for job types that have no
// dedicated admin mutation, so newly added engine job types are triggerable
// from the Create Job modal without a frontend code change. The backend
// validates `type` against its job-schema registry and rejects unknown types.
export const adminEnqueueJob = `mutation AdminEnqueueJob($type: String!, $parameters: JSON, $tenderId: String, $cronSchedule: String) {
    adminEnqueueJob(type: $type, parameters: $parameters, tenderId: $tenderId, cronSchedule: $cronSchedule) {
        success
        message
        jobId
        error
    }
}`;

// ==================== JOB MANAGEMENT MUTATIONS ====================

export const adminStartJob = `mutation AdminStartJob($jobId: String!) {
    adminStartJob(jobId: $jobId) {
        success
        message
        jobId
        error
    }
}`;

export const adminCompleteJob = `mutation AdminCompleteJob($jobId: String!, $result: JSON) {
    adminCompleteJob(jobId: $jobId, result: $result) {
        success
        message
        jobId
        error
    }
}`;

export const adminFailJob = `mutation AdminFailJob($jobId: String!, $error: String!) {
    adminFailJob(jobId: $jobId, error: $error) {
        success
        message
        jobId
        error
    }
}`;

export const adminRetryJob = `mutation AdminRetryJob($jobId: String!) {
    adminRetryJob(jobId: $jobId) {
        success
        message
        jobId
        error
    }
}`;

export const adminCancelJob = `mutation AdminCancelJob($jobId: String!) {
    adminCancelJob(jobId: $jobId) {
        success
        message
        error
    }
}`;

export const adminCleanupOldJobs = `mutation AdminCleanupOldJobs($olderThanDays: Int!) {
    adminCleanupOldJobs(olderThanDays: $olderThanDays) {
        success
        message
        deletedCount
        error
    }
}`;

// Bulk-cancel every PENDING job of one company (support tool for runaway
// per-company fan-outs, e.g. a misconfigured scheduled workflow).
export const adminCancelPendingJobsByCompany = `mutation AdminCancelPendingJobsByCompany($companyId: String!) {
    adminCancelPendingJobsByCompany(companyId: $companyId) {
        success
        message
        deletedCount
        error
    }
}`;

export const adminFixStuckJobs = `mutation AdminFixStuckJobs($olderThanHours: Int!) {
    adminFixStuckJobs(olderThanHours: $olderThanHours) {
        success
        message
        fixedJobs {
            id
            type
            status
        }
        fixedCount
        error
    }
}`;

export const adminGetPendingJobs = `mutation AdminGetPendingJobs($limit: Int) {
    adminGetPendingJobs(limit: $limit) {
        success
        message
        jobs {
            id
            type
            status
            tenderId
            createdAt
        }
        count
        error
    }
}`;

export const adminEnableScheduledJob = `mutation AdminEnableScheduledJob($jobId: String!) {
    adminEnableScheduledJob(jobId: $jobId) {
        success
        message
        jobId
        error
    }
}`;

export const adminDisableScheduledJob = `mutation AdminDisableScheduledJob($jobId: String!) {
    adminDisableScheduledJob(jobId: $jobId) {
        success
        message
        jobId
        error
    }
}`;

export const adminUpdateScheduledJob = `mutation AdminUpdateScheduledJob($jobId: String!, $cronSchedule: String, $parameters: JSON) {
    adminUpdateScheduledJob(jobId: $jobId, cronSchedule: $cronSchedule, parameters: $parameters) {
        success
        message
        jobId
        error
    }
}`;

// Manually trigger a scheduled job — creates a child run that inherits type, parameters, tenderId, priority.
// Dedup semantics: if a child is already pending/running, returns that existing child with success=true.
// Disabled schedules can still be triggered (for debugging).
export const adminTriggerScheduledJob = `mutation AdminTriggerScheduledJob($jobId: String!) {
    adminTriggerScheduledJob(jobId: $jobId) {
        success
        message
        jobId
        error
    }
}`;

// V32: Reset stale jobs (running but no heartbeat within threshold) back to pending
export const adminResetStaleJobs = `mutation AdminResetStaleJobs($thresholdMinutes: Int!) {
    adminResetStaleJobs(thresholdMinutes: $thresholdMinutes) {
        success
        message
        resetCount
        error
    }
}`;
